<template>
	<div id="wrap">
		<div class="flex flex-end">
			<el-button type="primary" @click="handleAdd">新增</el-button>
		</div>

		<el-dialog
			title="上年度高新技术产品(服务)情况表"
			:visible.sync="centerDialogVisible"
			width="66%"
			center
		>
			<el-form
				:model="formData"
				:rules="rules"
				v-loading="loading"
				ref="formData"
				class="demo-ruleForm"
			>
				<div>
					<div class="content">
						<el-row type="flex" class="row-bg" justify="space-between">
							<el-col :span="11">
								<el-form-item
									label="产品编号"
									prop="highTechApprovalPreviousProductBO.productNumber"
									label-width="40%"
								>
									<el-input
										v-model="
											formData.highTechApprovalPreviousProductBO.productNumber
										"
										placeholder="请填写"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="产品(服务)名称"
									prop="highTechApprovalPreviousProductBO.productName"
									label-width="40%"
								>
									<el-input
										v-model="
											formData.highTechApprovalPreviousProductBO.productName
										"
										placeholder="请填写"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item
									label="技术领域"
									:required="true"
									label-width="18%"
									class="flex flex-juftify from_center"
								>
									<el-form-item
										prop="highTechApprovalPreviousProductBO.tecFieldFirst"
									>
										<el-select
											v-model="
												formData.highTechApprovalPreviousProductBO.tecFieldFirst
											"
											@change="tecFieldCchange"
										>
											<el-option
												v-for="dict in tecFieldFirst"
												:key="dict.id"
												:label="dict.dictName"
												:value="dict.dictCode"
												placeholder="请选择"
											></el-option>
										</el-select>
									</el-form-item>

									<el-form-item
										prop="highTechApprovalPreviousProductBO.tecFieldSecond"
									>
										<el-select
											v-model="
												formData.highTechApprovalPreviousProductBO
													.tecFieldSecond
											"
											@change="tecFieldSecondCchange"
										>
											<el-option
												v-for="dict in tecFieldSecond"
												:key="dict.id"
												:label="dict.dictName"
												:value="dict.dictCode"
												placeholder="请选择"
											></el-option>
										</el-select>
									</el-form-item>

									<el-form-item
										prop="highTechApprovalPreviousProductBO.tecFieldThird"
									>
										<el-select
											v-model="
												formData.highTechApprovalPreviousProductBO.tecFieldThird
											"
										>
											<el-option
												v-for="dict in tecFieldThird"
												:key="dict.id"
												:label="dict.dictName"
												:value="dict.dictCode"
												placeholder="请选择"
											></el-option>
										</el-select>
									</el-form-item>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="技术来源"
									prop="highTechApprovalPreviousProductBO.tecSource"
									label-width="40%"
								>
									<el-select
										v-model="
											formData.highTechApprovalPreviousProductBO.tecSource
										"
									>
										<el-option
											v-for="dict in technologySource"
											:key="dict.id"
											:label="dict.dictName"
											:value="dict.dictCode"
											placeholder="请选择"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="上年度销售收入(万元)"
									prop="highTechApprovalPreviousProductBO.previousIncome"
									label-width="40%"
								>
									<el-input
										v-model="
											formData.highTechApprovalPreviousProductBO.previousIncome
										"
										maxlength="20"
										placeholder="请填写"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="11">
								<el-form-item
									label="是否主要产品服务"
									prop="highTechApprovalPreviousProductBO.isPrimaryProduct"
									label-width="40%"
								>
									<el-select
										v-model="
											formData.highTechApprovalPreviousProductBO
												.isPrimaryProduct
										"
									>
										<el-option
											v-for="dict in isIntellectualPropertyType"
											:key="dict.key"
											:label="dict.dictName"
											:value="dict.dictCode"
										></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="知识产权" prop="" label-width="20%">
									<el-transfer
										:titles="['未选数据', '已选数据']"
										v-model="formData.ids"
										:data="zscpData"
									></el-transfer>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item
									:label="'关键技术及主要技术指标' + '\n' + '(限400字以内)'"
									prop="highTechApprovalPreviousProductBO.mainTech"
									label-width="20%"
								>
									<el-input
										type="textarea"
										:rows="5"
										maxlength="400"
										show-word-limit
										v-model="
											formData.highTechApprovalPreviousProductBO.mainTech
										"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item
									:label="'与同类产品的优势\n(限400字以内)'"
									prop="highTechApprovalPreviousProductBO.advantage"
									label-width="20%"
								>
									<el-input
										type="textarea"
										:rows="5"
										maxlength="400"
										show-word-limit
										v-model="
											formData.highTechApprovalPreviousProductBO.advantage
										"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item
									:label="
										'知识产权获得情况及其对产品在技术上发挥的支持作用\n(限400字以内)'
									"
									prop="highTechApprovalPreviousProductBO.effect"
									label-width="20%"
								>
									<el-input
										type="textarea"
										:rows="5"
										maxlength="400"
										show-word-limit
										v-model="formData.highTechApprovalPreviousProductBO.effect"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="证明材料(pdf)" prop="" label-width="20%">
									<el-upload
										ref="upload"
										class="upload-demo"
										:action="uploadImgUrl"
										:on-success="quillImgSuccess"
										:on-preview="handleView"
										:on-remove="handleRemove"
										:on-error="uploadError"
										:before-upload="beforeUpload"
										:data="{ moduleType: 5 }"
										accept=".pdf"
										:file-list="fileList"
									>
										<el-button size="small" type="primary">点击上传</el-button>
									</el-upload>
								</el-form-item>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false" v-loading="loading"
					>返回</el-button
				>
				<el-button
					type="primary"
					@click="classSubmitForm"
					:disabled="disabled"
					v-loading="loading"
					>保存</el-button
				>
			</span>
		</el-dialog>

		<el-table
			class="table"
			:data="datas"
			:header-cell-style="{ background: '#F5F7FA' }"
			stripe
			:row-class-name="tableRowClassName"
		>
			<el-table-column label="序号" width="100" prop="date">
				<template slot-scope="scope">
					<span>{{ scope.$index + 1 }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="productNumber" label="产品编号" width="160">
			</el-table-column>
			<el-table-column
				prop="productName"
				label="产品(服务)名称"
			></el-table-column>
			<el-table-column label="技术领域" prop="techField"></el-table-column>
			<el-table-column label="技术来源" prop="techSource"></el-table-column>
			<el-table-column
				label="上年度销售收入(万元)"
				prop="previousIncome"
			></el-table-column>
			<el-table-column
				label="是否主要产品(服务)"
				prop="isPrimaryProduct"
			></el-table-column>
			<el-table-column label="操作" width="140" fixed="right">
				<template slot-scope="scope">
					<el-button
						type="text"
						size="small"
						class="green"
						@click="handleUpdate(scope.row.id)"
						>编辑</el-button
					>
					<el-button
						type="text"
						size="small"
						class="red"
						@click="handleDelete(scope.row.id)"
						>删除</el-button
					>
				</template>
			</el-table-column>
		</el-table>
		<div class="flex flex-end">
			<el-pagination
				class="pagination"
				background
				v-show="total > 0"
				:total="total"
				:current-page.sync="queryParams.pageNum"
				:page-size.sync="queryParams.pageSize"
				@current-change="getList"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	getDict,
	enterpriseDevelopmentActivityQueryAllProperty,
	queryDictDataByTypeAndCode,
	getModuleFiles,
	highTechProductQueryAll,
	highTechProductQuery,
	highTechProductSave,
	highTechProductDelete
} from "@/api/ChinaHigh";
export default {
	name: "serve",
	props: {
		id: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			isIntellectualPropertyType: [
				{ dictName: "是", dictCode: 1 },
				{ dictName: "否", dictCode: 2 }
			],
			// 数据
			datas: [],
			total: 0,
			loading: true,
			// 弹框
			centerDialogVisible: false,
			queryParams: {},
			formData: {
				highTechApprovalPreviousProductBO: {},
				fileBindVOList: [],
				ids: []
			},
			rules: {
				"highTechApprovalPreviousProductBO.productNumber": [
					{ required: true, message: "请输入产品编号", trigger: "blur" }
				],
				"highTechApprovalPreviousProductBO.productName": [
					{ required: true, message: "请输入产品(服务)名称", trigger: "blur" }
				],
				"highTechApprovalPreviousProductBO.tecFieldFirst": [
					{ required: true, message: "请选择技术领域", trigger: "change" }
				],
				"highTechApprovalPreviousProductBO.tecFieldSecond": [
					{ required: true, message: "请选择技术领域", trigger: "change" }
				],
				"highTechApprovalPreviousProductBO.tecFieldThird": [
					{ required: true, message: "请选择技术领域", trigger: "change" }
				],
				"highTechApprovalPreviousProductBO.tecSource": [
					{ required: true, message: "请选择技术来源", trigger: "change" }
				],
				"highTechApprovalPreviousProductBO.previousIncome": [
					{
						required: true,
						message: "请输入上年度销售收入(万元)",
						trigger: "blur"
					}
				],
				"highTechApprovalPreviousProductBO.isPrimaryProduct": [
					{
						required: true,
						message: "请选择是否主要产品服务",
						trigger: "change"
					}
				]
			},
			//日期限制
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6;
				}
			},
			fileList: [],
			zscpData: [],
			tecFieldFirst: {},
			tecFieldSecond: {},
			tecFieldThird: {},
			// 技术来源
			technologySource: {},
			disabled: false
		};
	},
	created() {
		this.handleQuery();
	},
	methods: {
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		/** 搜索按钮操作 */
		handleQuery() {
			this.queryParams.approvalId = this.id;
			this.queryParams.pageNum = 1;
			this.queryParams.pageSize = 10;
			this.getList();
		},
		/** 列表 */
		getList() {
			this.loading = true;
			highTechProductQueryAll(this.queryParams).then(res => {
				this.datas = res.data.records;
				this.total = res.data.total;
				this.loading = false;
				console.log(this.datas);
				for (let i = 0; i < this.datas.length; i++) {
					if (this.datas[i].isPrimaryProduct == 1) {
						this.datas[i].isPrimaryProduct = "是";
					} else {
						this.datas[i].isPrimaryProduct = "否";
					}
				}
			});
		},
		chushi() {
			this.zscpData = [];
			// 技术领域1
			getDict({ type: "technical_field", parentId: 0 }).then(res => {
				this.tecFieldFirst = res.data;
			});
			// 技术来源
			getDict({ type: "technology_source", parentId: 0 }).then(res => {
				this.technologySource = res.data;
			});
			enterpriseDevelopmentActivityQueryAllProperty(this.id).then(res => {
				res.data.forEach(re => {
					this.zscpData.push({
						key: re.id,
						label: re.intellectualNumber
					});
				});
			});
			this.formData = {
				highTechApprovalPreviousProductBO: {},
				fileBindVOList: [],
				ids: []
			};
			this.fileList = [];
			this.resetFiles("upload");
			this.resetForm("formData");
		},
		handleAdd() {
			this.chushi();
			this.centerDialogVisible = true;
		},
		handleUpdate(id) {
			this.chushi();
			highTechProductQuery(id, this.id).then(res => {
				if (
					res.data.highTechApprovalPreviousProductBO.tecFieldFirst !== "" &&
					res.data.highTechApprovalPreviousProductBO.tecFieldFirst !== null
				) {
					this.jishu(
						res.data.highTechApprovalPreviousProductBO.tecFieldFirst,
						1,
						2
					);
				}
				if (
					res.data.highTechApprovalPreviousProductBO.tecFieldSecond !== "" &&
					res.data.highTechApprovalPreviousProductBO.tecFieldSecond !== null
				) {
					this.jishu(
						res.data.highTechApprovalPreviousProductBO.tecFieldSecond,
						2,
						2
					);
				}
				this.formData.highTechApprovalPreviousProductBO =
					res.data.highTechApprovalPreviousProductBO;
				if (res.data.ids == null || res.data.ids == "") {
					this.formData.ids = [];
				} else {
					this.formData.ids = res.data.ids;
				}
				getModuleFiles({
					moduleId: res.data.highTechApprovalPreviousProductBO.id,
					moduleType: 5
				}).then(res => {
					this.formData.fileBindVOList = res.data;
					res.data.forEach(re => {
						this.fileList.push({
							name: re.fileName,
							fileName: re.fileName,
							url: re.url,
							moduleId: re.moduleId,
							moduleType: re.moduleType,
							path: re.path,
							id: re.id
						});
					});
				});
				this.centerDialogVisible = true;
			});
		},
		classSubmitForm() {
			this.formData.highTechApprovalPreviousProductBO.approvalId = this.id;
			var files = this.$refs.upload.uploadFiles;
			this.$refs["formData"].validate(valid => {
				if (files.length <= 0) {
					this.$message({
						message: "请上传附件！",
						type: "error"
					});
				}
				if (valid && files.length > 0) {
					highTechProductSave(this.formData).then(res => {
						if (res.code === "00000") {
							this.handleQuery();
							this.centerDialogVisible = false;
							this.msgSuccess(res.msg);
						}
					});
				} else {
					return false;
				}
			});
		},
		handleDelete(id) {
			var that = this;
			this.$confirm("是否确认删除研发开发费用吗?", "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(function() {
					return highTechProductDelete({ approvalId: that.id, ids: [id] });
				})
				.then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				})
				.catch(function() {});
		},
		typeFormat(row) {
			return this.selectDictLabel(
				this.isIntellectualPropertyType,
				row.isIntellectualProperty
			);
		},
		tecFieldCchange(val) {
			this.jishu(val, 1, 1);
		},
		tecFieldSecondCchange(val) {
			this.jishu(val, 2, 1);
		},
		// 技术领域
		jishu(val, type, stauts) {
			queryDictDataByTypeAndCode({ code: val, type: "technical_field" }).then(
				res => {
					if (type == 1) {
						if (stauts == 1) {
							this.tecFieldThird = {};
							this.$set(
								this.formData.highTechApprovalPreviousProductBO,
								"tecFieldSecond",
								""
							);
							this.$set(
								this.formData.highTechApprovalPreviousProductBO,
								"tecFieldThird",
								""
							);
						}
						this.tecFieldSecond = res.data;
					} else {
						if (stauts == 1) {
							this.$set(
								this.formData.highTechApprovalPreviousProductBO,
								"tecFieldThird",
								""
							);
						}
						this.tecFieldThird = res.data;
					}
				}
			);
		},
		beforeUpload(file, fileList) {
			let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (suffix != "pdf") {
				this.msgError("只能上传pdf格式的文件");
				return false;
			} else {
				// this.loading = true;
			}
		},
		// 上传成功
		quillImgSuccess(res, file, fileList) {
			this.loading = false;
			// 如果上传成功
			if (res.code === "00000") {
				this.formData.fileBindVOList.push(res.data);
				this.msgSuccess("附件上传成功");
			} else {
				this.msgError("附件上传失败");
			}
			let status = "";
			fileList.some(res => {
				if (res.status != "success") {
					status = 1;
					return;
				}
			});
			if (status != 1) {
			}
		},
		// 图片删除
		handleRemove(file, fileList) {
			this.formData.fileBindVOList = [];
			fileList.forEach(res => {
				if (res.response == undefined) {
					this.formData.fileBindVOList.push(res);
				} else {
					this.formData.fileBindVOList.push(res.response.data);
				}
			});
		},
		// 富文本图片上传失败
		uploadError(err, file, fileList) {
			this.loading = false;
			if (fileList.length > 0) {
				let status = "";
				fileList.some(res => {
					if (res.status != "success") {
						status = 1;
						return;
					}
				});
				if (status != 1) {
					this.disabled = false;
				}
			} else {
				this.disabled = false;
			}
			// loading动画消失
			this.msgError("图片上传失败");
		}
	}
};
</script>

<style scoped>
.flex .el-button {
	margin-bottom: 10px;
}
.button_box {
	margin-top: 20px;
}
.button_box button {
	padding: 10px 60px;
}
.image {
	width: 100%;
	height: auto;
}
.select_box {
	display: flex;
	justify-content: space-between;
}
.select_box .el-select {
	width: 30% !important;
}
.textarea {
	width: 90%;
	height: 164px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	resize: none;
}

.wrap {
	width: 84%;
	margin-left: 16%;
}

.row-bg {
	width: 84%;
	margin: 0 auto;
	flex-wrap: wrap;
}

.content {
	margin-top: 30px;
	background: #fff;
	width: 100%;
}
.content .text {
	font-size: 13px;
	padding: 10px 20px;
	border-bottom: 1px solid #d4d4d4;
	position: relative;
}
.accessory_box {
	width: 100%;
}
.accessory_box > div {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px 0;
}

.content .text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}
.el-table .cell {
	white-space: pre-line;
}
.el-select {
	width: 100%;
}
/deep/ .el-form-item__label {
	white-space: pre-line;
}
</style>
